import React, { Fragment, memo } from "react";
import { Eye, EyeOff } from 'lucide-react';

const EyeIcon = ({ showPassword, setShowPassword }) => {
    return (
        <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
        >
            {
                showPassword ? (
                    <EyeOff size={18} className="text-gray-400 hover:text-gray-200" />
                ) : (
                    <Eye size={18} className="text-gray-400 hover:text-gray-200" />
                )
            }
        </button>
    )
}

export default memo(EyeIcon);